import { useQuery } from "@apollo/client";
import { TherapistProfile } from "../../api/graphql/gql_queries.types";
import { GET_THERAPIST_PROFILE } from "../../api/graphql/gql_queries";

function useTherapistData() {
  return useQuery<TherapistProfile>(GET_THERAPIST_PROFILE);
}

export default useTherapistData;
